import allImgPaths from 'assets/images';
import ChatBox from 'components/ChatBox';
import FeteDescription from 'components/FeteDescription';
import Footer from 'components/Footer';
import CardWrapper from 'components/board/CardWrapper';
import UploadFileModal from 'components/chat/Body/UploadDocument';
import Header from 'components/common/Header';
import Sidebar from 'components/common/Sidebar';
import { CHAT_SESSION, DEFAULT_FETEBUDDY_INITIATE_MESSAGES, DEFAULT_FETEBUDDY_PROMPT_KEYS, MESSAGE_TYPES } from 'constants/llm';
import useAppState from 'context/useAppState';
import { format } from 'date-fns';
import { isNumber, isString } from 'lodash';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEventsData } from 'services/board';
import { getChatSessions } from 'services/chat';
import { getEventTasks } from 'services/event';
import { EVENT_DEFAULTS } from 'utils/constant';
import { getFeteFormatByNumber } from 'utils/fete';
import { formatNumber, jsonToMarkdown } from 'utils/function';
import { getAnswerFromResponse } from 'utils/llm';
import { v4 as uuidv4 } from 'uuid';

function NewFete() {

	const { setState: setChatboxState, getLLMResponse, createNewEvent, getExistingEvent, initNewFete } = useAppState('chatBox');
	const { draftEventId } = useParams()
	const { setState: setNewFeteChatState, newFeteDetails, draftEventTasks } = useAppState('newFeteChat')
	const [isChatInitiated, setIsChatInitiated] = useState(false);
	const { setState: setChatMessagesState, messageHistory, createSession, getUserChatSessions, getUserChatSessionMessages } = useAppState('chatMessages');

	const userData = JSON.parse(localStorage.getItem('userData') as string)
	const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

	const getMetadataFilter = ({ ...additional }: any) => {
		return {
			teamId: currentTeam?.currentTeamId,
			userId: userData?.id,
			...additional,
		}
	}

	const getChatSessions = async (eventId: string) => {
		const userSessions = await getUserChatSessions({
			page: 0,
			perPage: 10,
			filter: getMetadataFilter({ eventId: eventId }),
		});
		return userSessions;
	}

	useEffect(() => {
		if (isChatInitiated || initNewFete && messageHistory?.length === 0) {
			(async () => {
				let event, sessionRes;
				if (draftEventId) {
					// Get existing draft event
					const { data: eventData } = await getEventsData(draftEventId)
					event = eventData;
					// Get chat session with messages
					const userSessions = await getChatSessions(draftEventId);
					if (userSessions && userSessions?.sessions && userSessions?.sessions?.length > 0) {
						setChatboxState({ currentSession: userSessions?.sessions[0] })
						const chatSessionMessages = await getUserChatSessionMessages(userSessions?.sessions[0]._id)
						setChatMessagesState({ messageHistory: chatSessionMessages, showChatLoader: false })
					} else {
						setChatMessagesState({ messageHistory: [], showChatLoader: true })
						sessionRes = await createSession({
							title: CHAT_SESSION.DRAFT_TITLE,
							metadata: getMetadataFilter({ eventId: event?._id })
						});
						setChatboxState({ currentSession: sessionRes })
						const llmRes = await getLLMResponse({
							input_variables: {
								tasks: draftEventTasks?.length > 0 ? jsonToMarkdown(draftEventTasks) : ''
							},
							userMessage: DEFAULT_FETEBUDDY_INITIATE_MESSAGES.START,
							promptKey: DEFAULT_FETEBUDDY_PROMPT_KEYS.START,
							session_id: sessionRes?._id,
							metadata_filter: getMetadataFilter({ eventId: event?._id })
						});
						setChatMessagesState({ messageHistory: [{ type: MESSAGE_TYPES.AI, content: getAnswerFromResponse(llmRes), createdAt: new Date().toISOString() }], showChatLoader: false })
					}
				}
				if (event) {
					setNewFeteChatState({ draftEvent: event })
					setNewFeteChatState({
						newFeteDetails: {
							event_title: event?.name || null,
							event_type: event?.type,
							event_format: isString(event?.format) ? event?.format : isNumber(event?.format) ? getFeteFormatByNumber(event?.format) : null,
							event_start_date: isNumber(event?.start_date) ? new Date(event?.start_date).toISOString().split('T')[0] : event?.start_date,
							event_end_date: isNumber(event?.end_date) ? new Date(event?.end_date).toISOString().split('T')[0] : event?.end_date,
							event_minimum_budget: event?.budget?.min,
							event_maximum_budget: event?.budget?.max,
							event_location: event?.locations[0],
							event_minimum_number_of_attendees: event?.attendees?.min,
							event_maximum_number_of_attendees: event?.attendees?.max,
							event_objective: event?.objective
						}
					})
				}
				const { data } = await getEventTasks(event?._id)
				const tasks: any = [];
				if (data && data?.length > 0) {
					data?.forEach((item: any) => {
						item?.tasks.forEach((task: any) => {
							tasks.push({ _id: task?._id, taskId: task?._id, title: task?.title, is_completed: task?.is_completed, cardTitle: item?.title })
						})
					})
				}
				setNewFeteChatState({ draftEventTasks: tasks })
			})()
		}
	}, [isChatInitiated, initNewFete])

	useEffect(() => {
		setChatMessagesState({ showChatLoader: true })
		setIsChatInitiated(true);
	}, [])

	const getEventDate = () => {
		if (!newFeteDetails?.event_start_date && !newFeteDetails?.event_end_date) {
			return '--'
		} else {
			let startDate = newFeteDetails?.event_start_date ? (isNaN(newFeteDetails?.event_start_date) ? newFeteDetails?.event_start_date : format(newFeteDetails?.event_start_date, 'dd MMM yyyy')) : null
			let endDate = newFeteDetails?.event_end_date ? (isNaN(newFeteDetails?.event_end_date) ? newFeteDetails?.event_end_date : format(newFeteDetails?.event_end_date, 'dd MMM yyyy')) : null

			let eventDate = startDate ? startDate : '';
			if (startDate && endDate
				&& startDate !== endDate
			) {
				eventDate = eventDate.concat(' - ')
			}
			if (endDate && endDate !== startDate) {
				eventDate = eventDate.concat(`${endDate}`)
			}
			return eventDate;

			// let eventDate = newFeteDetails?.event_start_date ? newFeteDetails?.event_start_date : '';
			// if (newFeteDetails?.event_start_date && newFeteDetails?.event_end_date
			// 	&& newFeteDetails?.event_start_date !== newFeteDetails?.event_end_date
			// ) {
			// 	eventDate = eventDate.concat(' - ')
			// }
			// if (newFeteDetails?.event_end_date && newFeteDetails?.event_end_date !== newFeteDetails?.event_start_date) {
			// 	eventDate = eventDate.concat(`${newFeteDetails?.event_end_date}`)
			// }
			// return eventDate;
		}
	}

	const getEventNumberOfAttendees = () => {
		if (!newFeteDetails?.event_minimum_number_of_attendees && !newFeteDetails?.event_maximum_number_of_attendees) {
			return '--'
		} else {
			let eventNumberOfAttendees = newFeteDetails?.event_minimum_number_of_attendees ? formatNumber(newFeteDetails?.event_minimum_number_of_attendees) : '';
			if (newFeteDetails?.event_minimum_number_of_attendees && newFeteDetails?.event_maximum_number_of_attendees
				&& newFeteDetails?.event_minimum_number_of_attendees !== newFeteDetails?.event_maximum_number_of_attendees
			) {
				eventNumberOfAttendees = eventNumberOfAttendees.concat(' - ')
			}
			if (newFeteDetails?.event_maximum_number_of_attendees && newFeteDetails?.event_maximum_number_of_attendees !== newFeteDetails?.event_minimum_number_of_attendees) {
				eventNumberOfAttendees = eventNumberOfAttendees.concat(`${formatNumber(newFeteDetails?.event_maximum_number_of_attendees)}`)
			}
			return eventNumberOfAttendees;
		}
	}

	const getEventBudget = () => {
		if (!newFeteDetails?.event_minimum_budget && !newFeteDetails?.event_maximum_budget) {
			return '--'
		} else {
			let eventBudget = newFeteDetails?.event_minimum_budget ? formatNumber(newFeteDetails?.event_minimum_budget) : '';
			if (newFeteDetails?.event_minimum_budget && newFeteDetails?.event_maximum_budget
				&& newFeteDetails?.event_minimum_budget !== newFeteDetails?.event_maximum_budget
			) {
				eventBudget = eventBudget.concat(' - ')
			}
			if (newFeteDetails?.event_maximum_budget && newFeteDetails?.event_maximum_budget !== newFeteDetails?.event_minimum_budget) {
				eventBudget = eventBudget.concat(`${formatNumber(newFeteDetails?.event_maximum_budget)}`)
			}
			return eventBudget;
		}
	}

	return (
		<div className="dashboard-wrapper flex">
			{/* Sidebar */}
			<Sidebar />

			{/* dashboard main */}
			<div className="w-[calc(100%_-_72px)] ml-auto">
				{/* Header */}
				<Header />

				{/* Main */}
				<div className="pt-2.5 h-[calc(100vh_-_57px)] card-animation overflow-y-auto bg-grad-grey">
					<div className="card-anim-structure-upper px-6">
						<div className="flex gap-x-6 relative card-anim-fete-description planning-anim-fete-description">
							<div className="mb-4 planning-fete-description px-3 py-3 border border-[#D0D5DD] rounded-xl !pb-0 self-start bg-white">
								<div className="relative h-[282px] w-[334px] rounded-xl mb-4">
									<img className="rounded-xl object-cover w-full h-full" src={allImgPaths.blankImg} alt="" />
								</div>
								<div className="planning-fete-info min-w-[280px] min-h-[280px] !shadow-none !p-0 !w-auto">
									<div className="flex gap-x-2 items-center pb-2">
										<span className="text-sm text-[#1E0AF5] font-interSemiBold">{newFeteDetails?.event_type || 'Fete Type'}</span>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											{newFeteDetails?.event_format || 'Fete Format'}
										</span>
									</div>

									<h6 className="font-interMedium text-xl text-[#101828] pb-3">{newFeteDetails?.event_title || EVENT_DEFAULTS.title}</h6>

									<div className="flex items-center gap-x-2 mb-3 card-anim-organiser">
										<span className="text-[#475467] text-base">Organisers : </span>
										<div className="flex items-center ">
											<div className="w-8 h-8 rounded-full -ml-2 border-2 border-[#fff] first:ml-0 relative group">
												<img
													className="w-full h-full rounded-full on-hover-border-shadow cursor-pointer"
													src={allImgPaths.defaultProfile || '--'}
													alt="profile"
												/>
												<div className="bg-[#0C111D] rounded-lg py-2 px-3 min-w-[122px] absolute z-10 top-full left-1/2 transform -translate-x-1/2 mt-2 hidden group-hover:block cursor-default">
													<span className="arrow-top w-0 h-0 block absolute left-1/2 transform -translate-x-1/2 -top-2"></span>
													<ul className="text-center">
														<li className="text-xs text-white pb-1 last:pb-0">
															You
														</li>
													</ul>
												</div>
											</div>

											{/* <div className="ml-2">
												<img
													className="w-8 h-8 rounded-full cursor-pointer"
													src={allImgPaths.plusIcon2}
													alt="plus icon"
												/>
											</div> */}
										</div>
									</div>

									<div className="card-anim-wrapper !block pb-3">
										<div className="flex items-start gap-x-2 pb-3">
											<img className="w-4 h-4 mt-1.5" src={allImgPaths.targetIcon} alt="target icon" />
											<span title={newFeteDetails?.event_objective} className="text-base text-[#344054] font-interMedium max-w-[305px] line-clamp-2">
												{newFeteDetails?.event_objective || '--'}
											</span>
										</div>

										<div className="flex items-center gap-x-2 pb-3">
											<img className="w-4 h-4" src={allImgPaths.calenderIcon} alt="target icon" />

											<span className="text-base text-[#344054] font-interMedium">
												{getEventDate()}
											</span>
										</div>

										<div className="flex items-center gap-x-2 pb-3">
											<img className="w-4 h-4" src={allImgPaths.teamIcon2} alt="target icon" />
											<span className="text-base text-[#344054] font-interMedium">
												{getEventNumberOfAttendees()}
											</span>
										</div>

										<div className="flex items-center gap-x-2 pb-3">
											<img className="w-4 h-4" src={allImgPaths.locationIcon} alt="target icon" />
											{newFeteDetails?.event_location || '--'}
										</div>

										<div className="flex items-center gap-x-2">
											<img className="w-4 h-4" src={allImgPaths.dollorIcon} alt="dollor icon" />
											<span className="text-base text-[#344054] font-interMedium">
												{getEventBudget()}
											</span>
										</div>
									</div>
								</div>
							</div>
							<UploadFileModal />
						</div>

						<div className="card-fete-chatbox rounded-bl-2xl rounded-br-2xl mb-4">
							<ChatBox />
						</div>
					</div>

					{/* Footer */}
					<Footer />
				</div>
			</div>
		</div>
	)
}

export default NewFete
